module.exports = __webpack_public_path__ + "img/buddy_eyes-04.cd0f5aa9.svg";